import React from 'react';
import '../styles/CTASection.css';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-content">
        <h2>Ready to Join Our Team?</h2>
        <p>If you don't see a position that matches your skills, we'd still love to hear from you. Send us your resume and we'll contact you when a suitable opportunity arises.</p>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSe0YyuB3VEcuuA8lVT9P6-cIjS_WuuPFbspX1TF4Eq7KKLwdg/viewform?usp=header" className="btn">Submit Your Resume</a>
      </div>
    </section>
  );
};

export default CTASection;